/** Glasronde 0.9.246 punt 4 (Frank, 5 nov): het TASQ-dagoverzicht in de Postbus toonde losse ** in de tekst. Een
 *  worker schrijft Markdown; de Postbus zette die als platte tekst neer.
 *
 *  Een eigen, kleine weergave en geen react-markdown: die kan de vastgezette Jest niet lezen (zie CouncilProgress), en
 *  een nieuwe afhankelijkheid vraagt een eigen GO. Hij kent wat een worker hier schrijft: koppen (#), vet (**...**),
 *  opsommingen (- of *) en lege regels. Al het andere blijft letterlijk staan; er wordt nooit HTML uit de tekst
 *  gemaakt, dus een tekst kan geen opmaak of script in de pagina zetten. */
import { Fragment } from "react";

const VET = /(\*\*[^*\n]+?\*\*|__[^_\n]+?__)/g;

/** Een regel met vet erin als React-stukken. PUUR. */
export function inline(tekst, sleutel = "") {
  return String(tekst).split(VET).map((stuk, i) => {
    const vet = /^(\*\*|__)(.+)\1$/.exec(stuk);
    return vet ? <strong key={`${sleutel}-${i}`}>{vet[2]}</strong> : <Fragment key={`${sleutel}-${i}`}>{stuk}</Fragment>;
  });
}

/** De tekst als blokken: [{ soort: "kop"|"punt"|"tekst"|"leeg", tekst }]. PUUR. */
export function blokken(tekst) {
  return String(tekst || "").split("\n").map((regel) => {
    const kop = /^\s{0,3}#{1,6}\s+(.*)$/.exec(regel);
    if (kop) return { soort: "kop", tekst: kop[1].replace(/\s*#+\s*$/, "") };
    const punt = /^\s*[-*•]\s+(.*)$/.exec(regel);
    if (punt) return { soort: "punt", tekst: punt[1], diep: /^\s{2,}/.test(regel) };
    if (!regel.trim()) return { soort: "leeg", tekst: "" };
    return { soort: "tekst", tekst: regel };
  });
}

export default function KorteOpmaak({ tekst, className = "", testid }) {
  return (
    <div className={`text-sm space-y-0.5 break-words ${className}`} data-testid={testid}>
      {blokken(tekst).map((b, i) => {
        if (b.soort === "kop") return <p key={i} className="font-semibold pt-1">{inline(b.tekst, i)}</p>;
        if (b.soort === "punt") {
          return (
            <p key={i} className={`flex gap-1.5 ${b.diep ? "pl-6" : "pl-2"}`}>
              <span aria-hidden="true">&bull;</span><span>{inline(b.tekst, i)}</span>
            </p>
          );
        }
        if (b.soort === "leeg") return <div key={i} className="h-2" />;
        return <p key={i}>{inline(b.tekst, i)}</p>;
      })}
    </div>
  );
}
